import { Modal, Space, Form, Input, Divider, message, Image } from "antd";
import React, { useState, useEffect } from "react";
import { createProject, uploadFile, updateProject } from "@/services/common";
import { UploadOutlined, RetweetOutlined } from "@ant-design/icons";
import { radomPics } from "@/config/const";

type FieldType = {
  name: string;
  description?: string;
  // owner_id: number;
  thumbnail_url?: string | null;
};

const Component = (props: any) => {
  const { status, setStatus, userInfo, loadData, type, source } = props;
  const [coverImg, setCoverImg] = useState<string | null>(null);
  const [form] = Form.useForm();

  const closeModal = () => {
    setStatus(false);
  };

  useEffect(() => {
    if (type === "create") {
      form.resetFields();
      setCoverImg(null);
    } else {
      form.setFieldsValue({
        name: source.name,
        description: source.description,
      });
      setCoverImg(source.thumbnail_url);
    }
  }, [status]);

  const upFile = async (e: any) => {
    const file = e.target.files[0];
    // setCurFile(file);
    // console.log(file);
    if (file.type === "image/gif" || file.type === "image/png" || file.type === "image/jpeg") {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadFile(formData, userInfo.access_token);
      const s = await res.json();
      // console.log(s);
      setCoverImg(s.fileUrl);
    } else {
      message.info("只允许上传图片文件，请重新上传！");
    }

    // console.log(s);
    // if (s.status === 200) {
    //   // const mol = await getMolInfo(formData);
    //   // const molJson = await mol.json();
    //   // console.log('molJson',molJson);
    //   // setMolInfo(molJson.data);
    //   // setCurModelUrl(s.data.url);
    // } else {
    //   message.error('文件上传失败！')
    // }
  };

  const onFinish = (values: FieldType) => {
    const subData = {
      ...values,
      thumbnail_url: coverImg ? coverImg : radomPics(),
      // owner_id: userInfo.id,
      owner_id: 1,
    };

    if (type === "create") {
      createProject(subData, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          closeModal();
          message.success("项目创建成功！");
          loadData();
        } else {
          message.error("项目创建失败！");
        }
      });
    } else {
      updateProject(source.id, subData, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          closeModal();
          message.success("项目修改成功！");
          loadData();
        } else {
          message.error("项目修改失败！");
        }
      });
    }

    // console.log("subData", subData);
  };

  const radom_thumbnail = async () => {
    const filePath = radomPics();
    setCoverImg(filePath);
  };
  return (
    <Modal
      title={
        <Space>
          <div className="t2">{type === "create" ? "新建项目" : "修改项目信息"}：</div>
        </Space>
      }
      open={status}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
      maskClosable={false}
      destroyOnHidden={true}
      width="55%"
      // afterOpenChange={()=>{

      // }}
      // closeIcon={<CloseCircleFilled style={{ color: '#FFF' }} />}
      //     okText: '确认',
      // cancelText: '取消',
      style={{ top: 40 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "5rem",
        }}
      >
        <Form
          name="createProject"
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 18 }}
          style={{ width: "70%" }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={<div className="t3">项目名称</div>}
            name="name"
            rules={[{ required: true, message: "请输入项目名称!" }]}
          >
            <Input size="large" style={{ borderRadius: 0 }} />
          </Form.Item>
          <Form.Item
            label={<div className="t3">项目封面</div>}
          // name="description"
          // rules={[{ required: true, message: '请输入项目名称!' }]}
          >
            {coverImg ? (
              <>
                <div style={{ width: "100%", border: "1px solid rgba(255,255,255,0.2)" }}>
                  <Image src={coverImg} width="100%" />
                </div>
                <Space className="mt1">
                  <div
                    className="button_new"
                    onClick={() => {
                      const s: any = document.getElementById("upimg");
                      s.click();
                    }}
                  >
                    <UploadOutlined /> 重新上传封面
                  </div>
                  <div className="button_cancle_new" onClick={radom_thumbnail}>
                    <RetweetOutlined /> 随机封面
                  </div>
                </Space>
              </>
            ) : (
              <Space>
                <div
                  className="button_new"
                  onClick={() => {
                    const s: any = document.getElementById("upimg");
                    s.click();
                  }}
                >
                  <UploadOutlined /> 上传封面图片
                </div>
                <div className="button_cancle_new" onClick={radom_thumbnail}>
                  <RetweetOutlined /> 随机封面
                </div>
              </Space>
            )}
            <input
              type="file"
              id="upimg"
              style={{ display: "none" }}
              onChange={upFile}
            // accept='.xyz'
            />
          </Form.Item>
          <Form.Item
            label={<div className="t3">项目描述</div>}
            name="description"
          // rules={[{ required: true, message: '请输入项目名称!' }]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>

          <Divider />
          <Form.Item wrapperCol={{ offset: 4, span: 18 }}>
            <Space>
              <div className="button_new" onClick={() => form.submit()}>
                {type === "create" ? "创建项目" : "确定修改"}
              </div>
              <div className="button_cancle_new" onClick={closeModal}>
                关闭
              </div>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default Component;
